export default "__VITE_ASSET__DSqr07jU__"